import { useEffect, useContext, useRef, useCallback } from "react";
import AuthContext from "../../../auth/AuthContext";
import AlertService from "../../../services/AlertService";

const MFAIdleTimeout = () => {
  const { logout } = useContext(AuthContext);
  const TIMEOUT = useRef(5 * 60 * 1000).current; // 5 mins
  const idleTimeRef = useRef(0);
  const idleIntervalRef = useRef(null);

  const resetIdleTimer = useCallback(() => {
    idleTimeRef.current = 0;
  }, []);

  useEffect(() => {
    const handleActivity = () => resetIdleTimer();
    const events = ["mousemove", "keydown", "click", "scroll"];
    events.forEach((e) => window.addEventListener(e, handleActivity));

    idleIntervalRef.current = setInterval(() => {
      idleTimeRef.current += 1000;

      if (idleTimeRef.current >= TIMEOUT) {
        AlertService.error("Session Expired");
        logout();
      }
    }, 1000);

    return () => {
      if (idleIntervalRef.current) clearInterval(idleIntervalRef.current);
      events.forEach((e) => window.removeEventListener(e, handleActivity));
    };
   // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetIdleTimer, logout]);

  return null; // no UI needed
};

export default MFAIdleTimeout;
